import React, { useState } from "react"
import {
  Box,
  Button,
  Container,
  TextField,
  Typography,
  AppBar,
  Toolbar,
  createTheme,
  ThemeProvider,
  useMediaQuery,styled
} from "@mui/material"
import { ReactComponent as EagleLogo } from '../Assets/15.svg';

const theme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#B77F0E",
    },
    background: {
      default: "#0D141A",
      paper: "#1C1F25",
    },
  },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            backgroundColor: "#fff",
            color: "#000",
            "& fieldset": {
              borderColor: "#fff",
            },
          },
        },
      },
    },
  },
})

const StyledFooter = styled(Box)(({ theme }) => ({
  backgroundColor: "#0D141A",
  color: "white",
  padding: theme.spacing(6, 0),
}))

const StyledButton = styled(Button)({
  backgroundColor: "#D4A017",
  color: "white",
  padding: "12px 24px",
  borderRadius: "4px",
  textTransform: "none",
  "&:hover": {
    backgroundColor: "#B8860B",
  },
  width: "100%",
  marginTop: "16px",
})

export default function ContactForm() {
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"))
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"))

  const [formData, setFormData] = useState({
    name: "",
    contact: "",
    email: "",
    message: "",
  })

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }))
  }

  const handleSubmit = async (event) => {
    event.preventDefault()

    const { name, contact, email, message } = formData

    try {
      const response = await fetch("https://backend.thegameofthemoney.com/admin/submitForm", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "access-key": 'ASDFGHJ23456$^%$*&dhsjdhshLMKNGBHGsjdgash23bsh',
        },
        body: JSON.stringify({
          name,   
          contact,
          email,
          message,
        }),
      })

      if (response.ok) {
        alert("Form submitted successfully")
        setFormData({
          name: "",
          contact: "",
          email: "",
          message: "",
        })
      } else {
        alert("There was an error submitting the form.")
      }
    } catch (error) {
      alert("There was an error submitting the form.")
    }
  }

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ minHeight: "100vh", bgcolor: "background.default" }}>
        <AppBar position="static" elevation={0} sx={{ bgcolor: "transparent", boxShadow: "none" }}>
          <Container maxWidth="lg">
            <Toolbar
              sx={{
                flexDirection: isMobile ? "column" : "row",
                justifyContent: "space-between",
                height: { xs: "auto", sm: "160px" },
                py: isMobile ? 2 : 0,
              }}
            >
              <Typography
                variant="body1"
                sx={{
                  color: "#fff",
                  borderBottom: "2px solid #fff",
                  cursor: "pointer",
                  mb: isMobile ? 2 : 0,
                }}
              >
                Home
              </Typography>
              <Box
                sx={{
                  position: isMobile ? "static" : "absolute",
                  left: isMobile ? "auto" : "50%",
                  top: isMobile ? "auto" : "50%",
                  transform: isMobile ? "none" : "translate(-50%, -50%)",
                  my: isMobile ? 2 : 0,
                }}
              >
                <EagleLogo
                  width={isMobile ? 120 : 170}
                  height={isMobile ? 180 : 250}
                />
              </Box>
            </Toolbar>
          </Container>
        </AppBar>

        <Box sx={{ height: "1px", bgcolor: "rgba(255, 255, 255, 0.05)", boxShadow: "0 1px 2px rgba(0, 0, 0, 0.1)" }} />

        <Container maxWidth="lg" sx={{ mt: { xs: 4, sm: 6 } }}>
          <Box sx={{ display: "flex", flexDirection: { xs: "column", md: "row" }, gap: { xs: 4, md: 8 } }}>
            {/* Left Column */}
            <Box sx={{ flex: 1, minWidth: { xs: "100%", md: "300px" }, mb: { xs: 4, sm: 0 } }}>
              <Typography
                variant="h2"
                sx={{ color: "#fff", fontWeight: "bold", mb: 3, fontSize: { xs: "2rem", sm: "2.5rem", md: "3rem" } }}
              >
                Contact Us Today
              </Typography>
              <Typography variant="body1" sx={{ color: "#fff", mb: 2 }}>
                Reach out to us by filling out the form.
              </Typography>
              <Typography variant="body1" sx={{ color: "#fff" }}>
                The Game Assistant will get back to you shortly to assist you.
              </Typography>
            </Box>

            {/* Right Column - Form */}
            <Box component="form" onSubmit={handleSubmit} sx={{ flex: 1, minWidth: { xs: "100%", md: "300px" } }}>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
                <Box sx={{ mb: "10px" }}>
                  <Typography sx={{ color: "#fff", mb: 1, textAlign: "left" }}>Enter Your Name*</Typography>
                  <TextField
                    fullWidth
                    placeholder="Your first name here"
                    variant="outlined"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                  />
                </Box>

                <Box sx={{ mb: "10px" }}>
                  <Typography sx={{ color: "#fff", mb: 1, textAlign: "left" }}>Enter Your Contact Number*</Typography>
                  <TextField
                    fullWidth
                    placeholder="Your contact number here"
                    variant="outlined"
                    name="contact"
                    value={formData.contact}
                    onChange={handleChange}
                  />
                </Box>

                <Box sx={{ mb: "10px" }}>
                  <Typography sx={{ color: "#fff", mb: 1, textAlign: "left" }}>Enter Your Email*</Typography>
                  <TextField
                    fullWidth
                    placeholder="Your email here"
                    variant="outlined"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                  />
                </Box>

                <Box sx={{ mb: "10px" }}>
                  <Typography sx={{ color: "#fff", mb: 1, textAlign: "left" }}>Enter Your Message*</Typography>
                  <TextField
                    fullWidth
                    multiline
                    rows={4}
                    placeholder="Your message here"
                    variant="outlined"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                  />
                </Box>

                <Button
                  type="submit"
                  variant="contained"
                  sx={{
                    bgcolor: "primary.main",
                    color: "#fff",
                    marginBottom: '10px',
                    py: 1.5,
                    width: { xs: "100%", sm: "fit-content" },
                    px: 4,
                    "&:hover": {
                      bgcolor: "#8E620B",
                    },
                  }}
                >
                  Submit
                </Button>
              </Box>
            </Box>
          </Box>
        </Container>
      </Box>

      <StyledFooter component="footer">
      <Container maxWidth="lg">
        <Box display="grid" gridTemplateColumns={{ xs: "1fr", md: "1fr 1fr 1fr" }} gap={4}>
          {/* Left Section */}
          <Box>
            <Typography variant="h4" fontWeight="bold" gutterBottom>
              The Game
            </Typography>
            <Typography variant="subtitle1" gutterBottom>
              Global Investment Advisor
            </Typography>
            <Typography variant="body2" sx={{ mt: 2 }}>
              Your success is our top priority and passion.
            </Typography>
          </Box>

          {/* Middle Section */}
          <Box>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              ADDRESS
            </Typography>
            <Typography variant="body2" paragraph>
              Gera's Imperium Rise, Opposite Wipro, Hinjewadi Phase II ,Pune - 411057
            </Typography>
            <Typography variant="body2" paragraph>
              +919175111029
            </Typography>
            <Typography variant="body2">info@thegameoftheinvestment.com</Typography>
          </Box>

          {/* Right Section */}
          <Box>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              SUBSCRIBE
            </Typography>
            <Typography variant="body2" gutterBottom>
              Enter your email address
            </Typography>
            <TextField
              fullWidth
              placeholder="Your email for updates"
              variant="outlined"
              sx={{
                backgroundColor: "white",
                borderRadius: 1,
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "transparent",
                  },
                },
              }}
            />
            <StyledButton>Submit your information now</StyledButton>
          </Box>
        </Box>

        {/* Disclaimer */}
        <Box sx={{ mt: 6, textAlign: "center" }}>
          <Typography variant="body2" sx={{ mb: 2 }}>
            Disclaimer : We are not SEBI Registered Advisor . All the advisory are for study and training purpose. No
            real money is involved.
          </Typography>
          <Typography variant="body2">© 2025 TheGame, Powered by YTC Tech Ventures. All rights reserved</Typography>
        </Box>
      </Container>
    </StyledFooter>
    </ThemeProvider>
  )
}
